import { render, staticRenderFns } from "./LogoBN.vue?vue&type=template&id=19cdff1c&scoped=true&"
import script from "./LogoBN.vue?vue&type=script&lang=js&"
export * from "./LogoBN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdff1c",
  null
  
)

export default component.exports